import React from "react";
import Tooltip from "./Tooltip";

function Skill({ tech, icon }) {
	return (
		<Tooltip tooltipText={tech}>
			<div className='p-2'>
				<div className='bg-gray-800 rounded flex p-3 md:p-4 h-full items-center'>
					<svg
						className='md:w-8 w-7'
						viewBox='0 0 128 128'
						dangerouslySetInnerHTML={{ __html: icon }}
					/>
				</div>
			</div>
		</Tooltip>
	);
}

export default Skill;
